<template>
  <div class="pa-4">
    <div class="d-flex align-center justify-space-between mb-6">
      <h2 class="text-h5 font-weight-black blue-grey--text text--darken-4 mb-0">
        Nueva Orden de Compra
      </h2>
    </div>

    <v-form ref="formPresentacion">
      <v-row class="mb-2">
        <v-col md="2" cols="12">
          <v-autocomplete
            :disabled="!editableAmc"
            label="Almacén"
            v-model="Compra.amc"
            :rules="rules.Requerido"
            :items="origenes"
            item-text="Nombre"
            item-value="id"
            outlined
            rounded
            dense
            hide-details
            background-color="white"
            class="elevation-1"
          >
          </v-autocomplete>
        </v-col>
        <v-col md="2" cols="12">
          <v-autocomplete
            label="Departamento"
            v-model="Compra.dpt"
            :rules="rules.Requerido"
            :items="modulos"
            outlined
            rounded
            dense
            hide-details
            background-color="white"
            class="elevation-1"
          >
          </v-autocomplete>
        </v-col>
        <v-col md="3" cols="12">
          <v-textarea
            label="Notas de la orden"
            placeholder="Anotaciones importantes para el proveedor o almacén..."
            v-model="notasProds"
            outlined
            rounded
            auto-grow
            rows="1"
            dense
            hide-details
            background-color="white"
            class="elevation-1 hide-scrollbar"
          ></v-textarea>
        </v-col>
        <v-col md="3" cols="12">
          <v-text-field
            label="Descripción"
            placeholder="Referencia de la orden..."
            v-model="Compra.dsc"
            outlined
            rounded
            dense
            hide-details
            background-color="white"
            class="elevation-1"
          >
          </v-text-field>
        </v-col>
        <v-col md="2" cols="12">
          <v-btn
            v-if="Compra.sts != 'A'"
            color="green"
            dark
            block
            @click="saveOrdenCompra()"
            >Guardar Orden
          </v-btn>
        </v-col>
      </v-row>
    </v-form>

    <template v-if="Compra.amc && Compra.dpt">
      <v-row class="mt-4">
        <template v-if="Compra.sts != 'A'">
          <!-- Left Column: Notes & Add Product -->
          <v-col cols="12" md="8" class="d-flex flex-column">
            <!-- Add Product Panel -->
            <v-card
              outlined
              class="rounded-xl elevation-1 text-center pa-6 d-flex flex-column justify-center flex-grow-1"
              style="border: 1px solid #eceff1"
              height="100%"
            >
              <h4
                class="mb-5 blue-grey--text text--darken-3 font-weight-black"
                style="letter-spacing: 1px"
              >
                AGREGAR PRODUCTO
              </h4>
              <v-form ref="formProdAdd">
                <v-row align="center" justify="center">
                  <v-col cols="12" md="12">
                    <v-autocomplete
                      label="Producto"
                      :rules="rules.Requerido"
                      v-model="prodSelected"
                      :items="global_prod"
                      item-text="Nombre"
                      item-value="id"
                      outlined
                      rounded
                      dense
                      hide-details
                      background-color="grey lighten-5"
                      append-icon="mdi-magnify"
                    >
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="12" md="12">
                    <v-autocomplete
                      label="Presentación"
                      :rules="rules.Requerido"
                      v-model="reqToAdd.prs"
                      :items="presentacionesBySelectedProd"
                      item-text="title"
                      item-value="Id"
                      outlined
                      rounded
                      dense
                      hide-details
                      background-color="grey lighten-5"
                      append-icon="mdi-chevron-down"
                    >
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="12" md="12">
                    <v-text-field
                      v-model.number="reqToAdd.cnt"
                      type="number"
                      outlined
                      rounded
                      dense
                      hide-details
                      background-color="grey lighten-4"
                      prepend-inner-icon="mdi-minus"
                      append-icon="mdi-plus"
                      class="centered-input font-weight-bold mx-2"
                      @click:prepend-inner="
                        reqToAdd.cnt > 1 ? reqToAdd.cnt-- : null
                      "
                      @click:append="reqToAdd.cnt++"
                      @keypress="$pgsHelper.onlyNumber($event, reqToAdd.cnt)"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" class="mt-4">
                    <v-btn
                      color="success"
                      rounded
                      block
                      depressed
                      class="px-8 font-weight-bold"
                      @click="addProd()"
                    >
                      Añadir a la orden
                    </v-btn>
                  </v-col>
                </v-row>
              </v-form>
            </v-card>
          </v-col>

          <!-- Right Column: Existencias Actuales -->
          <v-col cols="12" md="4">
            <v-card
              v-if="prodSelected"
              class="rounded-xl elevation-2 overflow-hidden"
              height="100%"
            >
              <v-toolbar color="blue-grey darken-4" dark dense flat>
                <v-toolbar-title
                  class="text-subtitle-2 font-weight-bold"
                  style="letter-spacing: 1px"
                  >EXISTENCIAS ACTUALES</v-toolbar-title
                >
                <v-spacer></v-spacer>
                <v-icon small color="blue-grey lighten-4"
                  >mdi-package-variant</v-icon
                >
              </v-toolbar>

              <v-card-text class="pa-5">
                <div
                  v-if="existenciasAlmacenes.principal"
                  class="mb-4 pa-4 rounded-xl light-green lighten-5"
                  style="border: 1px solid #c8e6c9"
                >
                  <div
                    class="text-caption light-green--text text--darken-3 font-weight-bold text-uppercase mb-1"
                  >
                    Almacén Seleccionado
                  </div>
                  <div class="d-flex justify-space-between align-center">
                    <div
                      class="font-weight-bold blue-grey--text text--darken-3"
                    >
                      {{ existenciasAlmacenes.principal.Nombre }}
                    </div>
                    <div
                      class="text-h6 font-weight-black light-green--text text--darken-4"
                    >
                      {{
                        $pgsHelper.formatNumber(
                          existenciasAlmacenes.principal.Stock,
                        )
                      }}
                      <span class="text-caption">{{
                        existenciasAlmacenes.principal.UM
                      }}</span>
                    </div>
                  </div>
                  <div
                    v-if="reqToAdd.prs && existenciasAlmacenes.principal.equivalente !== undefined"
                    class="text-right text-caption blue-grey--text text--darken-1 mt-1"
                  >
                    Equivale a
                    <span class="font-weight-bold">{{
                      $pgsHelper.formatNumber(
                        existenciasAlmacenes.principal.equivalente,
                      )
                    }}</span>
                    {{existenciasAlmacenes.principal.prs}}
                  </div>
                  
                </div>

                <template v-if="existenciasAlmacenes.secundarios.length">
                  <div
                    class="text-caption blue-grey--text text--lighten-1 font-weight-bold mb-3 text-uppercase"
                    style="letter-spacing: 1px"
                  >
                    OTROS ALMACENES
                  </div>
                  <div
                    v-for="almacen in existenciasAlmacenes.secundarios"
                    :key="almacen.id"
                    class="mb-3 pa-3 rounded-lg d-flex justify-space-between align-center"
                    :class="
                      almacen.Nombre.toLowerCase().includes('bodega')
                        ? 'pink lighten-5'
                        : 'light-green lighten-5'
                    "
                    :style="
                      'border: 1px solid ' +
                      (almacen.Nombre.toLowerCase().includes('bodega')
                        ? '#f8bbd0'
                        : '#c8e6c9')
                    "
                  >
                    <div
                      class="font-weight-medium"
                      :class="
                        almacen.Nombre.toLowerCase().includes('bodega')
                          ? 'pink--text text--darken-3'
                          : 'light-green--text text--darken-4'
                      "
                    >
                      {{ almacen.Nombre }}
                    </div>
                    <div
                      class="font-weight-bold"
                      :class="
                        almacen.Nombre.toLowerCase().includes('bodega')
                          ? 'pink--text text--darken-4'
                          : 'light-green--text text--darken-4'
                      "
                    >
                      {{ $pgsHelper.formatNumber(almacen.Stock) }}
                      <span class="text-caption">{{ almacen.UM }}</span>
                    </div>
                  </div>
                </template>
              </v-card-text>
            </v-card>
            <v-card
              v-else
              height="100%"
              class="rounded-xl elevation-1 d-flex flex-column align-center justify-center pa-6 text-center grey lighten-5"
              style="border: 2px dashed #cfd8dc; min-height: 200px"
            >
              <v-icon size="48" color="blue-grey lighten-3" class="mb-4"
                >mdi-store-search-outline</v-icon
              >
              <div class="blue-grey--text text--lighten-1 font-weight-medium">
                Seleccione un producto para<br />ver las existencias
              </div>
            </v-card>
          </v-col>
        </template>

        <!-- Requerimientos (Lista de Productos) -->
        <v-col
          cols="12"
          class="mt-1"
          v-if="Compra.adq && Compra.adq.length > 0"
        >
          <h3 class="mb-5 blue-grey--text text--darken-4 font-weight-black">
            Requerimientos
          </h3>
          <v-card
            v-for="(grupo, grupoIndex) in agrupadosPorProveedor"
            :key="'grupo-' + grupoIndex"
            class="mb-6 rounded-xl elevation-2 overflow-hidden"
          >
            <div
              class="px-5 py-3 grey lighten-4"
              style="border-bottom: 1px solid #eeeeee"
            >
              <div
                class="text-subtitle-2 font-weight-bold text-uppercase blue-grey--text text--darken-2"
                style="letter-spacing: 1px"
              >
                {{ grupo.proveedor }}
              </div>
            </div>

            <v-card-text class="pa-0">
              <div
                v-for="(pres, index) in grupo.items"
                :key="'item-' + index"
                class="px-5 py-4 d-flex flex-wrap align-center"
                :style="
                  index < grupo.items.length - 1
                    ? 'border-bottom: 1px solid #f5f5f5;'
                    : ''
                "
              >
                <!-- Presentación -->
                <v-col cols="12" sm="5" class="pa-0 pr-sm-4 mb-3 mb-sm-0">
                  <v-autocomplete
                    :disabled="Compra.sts == 'A'"
                    :items="presentacionesPorProductoMap.get(pres.prd) || []"
                    item-text="title"
                    item-value="Id"
                    label="Presentación"
                    v-model="pres.prs"
                    @change="actualizarFila(pres)"
                    outlined
                    rounded
                    dense
                    hide-details
                    background-color="grey lighten-5"
                  ></v-autocomplete>
                </v-col>

                <!-- Cantidad / Stepper -->
                <v-col
                  cols="12"
                  sm="2"
                  class="pa-0 pr-sm-4 mb-3 mb-sm-0 d-flex justify-center"
                >
                  <v-text-field
                    :disabled="Compra.sts == 'A'"
                    v-model.number="pres.cnt"
                    type="number"
                    outlined
                    rounded
                    dense
                    hide-details
                    background-color="grey lighten-4"
                    prepend-inner-icon="mdi-minus"
                    append-icon="mdi-plus"
                    class="centered-input font-weight-bold mx-2"
                    style="max-width: 140px"
                    @click:prepend-inner="pres.cnt > 1 ? pres.cnt-- : null"
                    @click:append="pres.cnt++"
                  ></v-text-field>
                </v-col>

                <!-- Compact Data Labels -->
                <v-col
                  cols="12"
                  sm="4"
                  class="pa-0 d-flex justify-space-between align-center px-sm-2 mb-3 mb-sm-0"
                  v-if="presentacionesMap.get(pres.prs)"
                >
                  <div
                    class="text-caption font-weight-medium d-flex flex-column align-center"
                  >
                    <span class="grey--text">Actual</span>
                    <div class="d-flex align-center">
                      <v-icon
                        v-if="getStockActual(pres.prd) < 0"
                        small
                        color="red"
                        class="mr-1"
                        >mdi-alert-circle</v-icon
                      >
                      <span
                        :class="
                          getStockActual(pres.prd) < 0
                            ? 'red--text font-weight-bold'
                            : 'blue-grey--text text--darken-3 font-weight-bold'
                        "
                      >
                        {{ $pgsHelper.formatNumber(getStockActual(pres.prd)) }}
                        {{ getUM(pres.prd) }}
                      </span>
                    </div>
                  </div>
                  <v-icon small color="grey lighten-1">mdi-arrow-right</v-icon>
                  <div
                    class="text-caption font-weight-medium d-flex flex-column align-center"
                  >
                    <span class="grey--text">Cant. a pedir</span>
                    <span
                      class="blue-grey--text text--darken-3 font-weight-bold"
                      >+{{
                        $pgsHelper.formatNumber(
                          Number(pres.cnt) *
                            Number(presentacionesMap.get(pres.prs).rdm || 1),
                        )
                      }}
                      {{ getUM(pres.prd) }}</span
                    >
                  </div>
                  <v-icon small color="grey lighten-1">mdi-equal</v-icon>
                  <div
                    class="text-caption font-weight-medium d-flex flex-column align-center"
                  >
                    <span class="grey--text">Total</span>
                    <div class="d-flex align-center">
                      <v-icon
                        v-if="
                          getStockActual(pres.prd) +
                            Number(pres.cnt) *
                              Number(presentacionesMap.get(pres.prs).rdm || 1) <
                          0
                        "
                        small
                        color="red"
                        class="mr-1"
                        >mdi-alert-circle</v-icon
                      >
                      <span
                        :class="
                          getStockActual(pres.prd) +
                            Number(pres.cnt) *
                              Number(presentacionesMap.get(pres.prs).rdm || 1) <
                          0
                            ? 'red--text font-weight-black'
                            : 'light-blue--text text--darken-4 font-weight-black'
                        "
                      >
                        {{
                          $pgsHelper.formatNumber(
                            getStockActual(pres.prd) +
                              Number(pres.cnt) *
                                Number(
                                  presentacionesMap.get(pres.prs).rdm || 1,
                                ),
                          )
                        }}
                        {{ getUM(pres.prd) }}
                      </span>
                    </div>
                  </div>
                </v-col>

                <!-- Trash -->
                <v-col cols="12" sm="1" class="pa-0 d-flex justify-end">
                  <v-btn
                    @click="deleteInsumo(pres.globalIndex)"
                    v-if="Compra.sts != 'A'"
                    icon
                    color="red lighten-1"
                  >
                    <v-icon>mdi-trash-can-outline</v-icon>
                  </v-btn>
                </v-col>
              </div>
            </v-card-text>
          </v-card>

          <ag-grid-vue
            v-if="false"
            style="height: 300px"
            class="ag-theme-alpine"
            :columnDefs="columnDefs"
            rowSelection="single"
            :rowData="Compra.adq"
            @gridReady="ongridReady($event)"
            @selection-changed="onSelectionChanged($event)"
          >
          </ag-grid-vue>
        </v-col>
      </v-row>
    </template>

    <template v-else>
      <v-row>
        <v-col>
          <v-alert
            type="info"
            color="blue-grey lighten-4"
            border="left"
            class="mt-4 rounded-lg blue-grey--text text--darken-4"
            icon="mdi-information-outline"
          >
            Selecciona un
            <strong class="blue-grey--text text--darken-4">Departamento</strong>
            y un
            <strong class="blue-grey--text text--darken-4">Almacén</strong> para
            comenzar.
          </v-alert>
        </v-col>
      </v-row>
    </template>
  </div>
</template>

<script>
import Compra from "../../../clases/Inventarios/Compras.js";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { AgGridVue } from "ag-grid-vue";
import moment from "moment";
import Currency from "../../../clases/Currencies.js";
export default {
  name: "ComprasForm",
  components: { AgGridVue },
  props: ["edit", "dataEdit", "presentaciones"],
  data() {
    return {
      notasProds: "",

      monedas: Currency.getCurrencies(),
      origenes: [],
      tipoOrden: "A",
      estatusList: Compra.getStatusList(),
      types: Compra.getTypes(),
      Compra: Compra.getPropertyModel(),
      rules: Compra.getRules(),
      columnDefs: null,
      editableAmc: true,
      prodSelected: null,
      reqToAdd: {
        prd: null,
        prs: "",
        nom: "",
        cnt: 1,
        pcu: { C: 0, M: "MXN" },
      },
      selection: [],
      OrdenesCompra: [],
      /*presentacion: PresentacionesAYB.getPropertyModel(),
          presentaciones:[],
          rules:PresentacionesAYB.getRules(),*/
      Proveedores: [],
    };
  },
  methods: {
    getAmcNombre() {
      const amc = this.origenes.find((o) => o.id == this.Compra.amc);
      return amc ? amc.Nombre : "";
    },
    getStockActual(prdId) {
      const origenesProds = this.$store.getters.getOrigenes || [];
      const doc = origenesProds.find((d) => d.Origen == this.Compra.amc);
      if (doc && doc.Productos && doc.Productos[prdId]) {
        return Number(doc.Productos[prdId].Stock || 0);
      }
      return 0;
    },
    getUM(prdId) {
      const producto = this.globalProdMap.get(prdId);
      return producto?.Extra?.AYB?.UM || "PZ";
    },
    actualizarFila(pres) {
      const presentacionEncontrada = this.presentaciones.find(
        (p) => p.Id === pres.prs,
      );
      if (presentacionEncontrada) {
        pres.prd = presentacionEncontrada.prd;
        const proveedor = this.proveedoresMap.get(presentacionEncontrada.pvd);
        pres.proveedor = proveedor ? proveedor.Nombre : "Proveedor no asignado";
      }
    },
    resetForm() {
      this.prodSelected = null;
      this.reqToAdd = {
        prd: null,
        prs: "",
        nom: "",
        cnt: 1,
        pcu: { C: 0, M: "MXN" },
      };
    },
    async getOrdenesCompra() {
      this.Documentos = [];
      const firestore = this.$store.getters.getFirebaseApp.firestore;
      var data = await firestore.queryBuilder("AMC_OrdenesCompra", [
        firestore.where(
          "Tenant",
          "==",
          this.$store.getters.getFirebaseApp.tenant,
        ),
      ]);

      //this.$pgsHelper.log(data.docs.map(doc=>{return {id:doc.ref.id,...doc.data()}}));
      let document = data.docs.map((doc) => {
        return { id: doc.ref.id, ...doc.data() };
      });

      document.forEach((data) => {
        let fecha = new moment(data.mmt, "YYYY-MM-DD_HH:mm:ss");
        this.Documentos.push({
          id: data.id,
          Nombre: "OC - " + fecha.format("YYYY-MM-DD HH:mm"),
          Fecha: fecha.format("YYYY-MM-DD HH:mm"),
          Aplicado: data.sts,
          Status: data.sts == "F" ? "Completado" : "Pendiente",
          ...data,
        });
      });

      this.OrdenesCompra = this.$_.orderBy(this.Documentos, "Fecha", "desc");
    },
    deleteInsumo(index) {
      this.Compra.adq.splice(index, 1);
    },
    onSelectionChanged(params) {
      const selectedRows = params.api.getSelectedRows();

      this.selection = selectedRows;
    },
    ongridReady: function (params) {
      let gridApi = params.api;
      gridApi.sizeColumnsToFit();
      let gridColumnApi = params.columnApi;
    },
    addProd() {
      if (this.$refs.formProdAdd.validate()) {
        let prod = this.$pgsHelper.getById(
          this.presentaciones,
          "Id",
          this.reqToAdd.prs,
        );

        let proveedor = this.proveedoresMap.get(prod.pvd) || {
          Nombre: "Proveedor no asignado",
        };
        this.reqToAdd.prd = this.prodSelected;
        this.reqToAdd.producto = prod.nom;
        this.reqToAdd.proveedor = proveedor.Nombre; // Nombre del proveedor.
        this.reqToAdd.globalIndex = this.Compra.adq.length;
        this.Compra.adq.push(this.$pgsHelper.cloneObj(this.reqToAdd));
        this.$refs.formProdAdd.reset();
        this.resetForm();
      }
    },
    async getOrigenes() {
      var data = await this.$store.getters.getFirebaseApp.database.queryBuilder(
        "PDV/Inventario/Origenes",
      );

      if (!data.exists()) {
        return false;
      }
      let arrayOrg = Object.entries(data.val());
      let origenes = [];
      arrayOrg.forEach((element) => {
        if (!this.$route.params.idDocumento) {
          this.Origen = element[0];
        }
        //this.Origen =  element[0];
        origenes.push({
          id: element[0],
          Nombre: element[1]["Nombre"],
          Departamentos: element[1]["Departamentos"],
        });
      });

      this.origenes = origenes;
    },
    saveOrdenCompra() {
      if (this.$refs.formPresentacion.validate()) {
        this.Compra.adq.forEach((prod) => {
          prod.cnt = Number(prod.cnt);
          prod.pcu.C = Number(prod.pcu.C);
        });
        this.Compra.sts = "OC";
        this.Compra.mmt = new moment().format("YYYY-MM-DD_HH:mm:ss");
        this.Compra.nts = this.notasProds;
        let datos = this.Compra;
        this.$alert.alertConfirm({
          action: this.edit ? "editar" : "agregar",
          obj: "la orden de compra",
          route: this.edit
            ? "AMC-Compras-updateCompra"
            : "AMC-Compras-createCompra",
          data: datos,
          onSuccess: () => {
            //this.getPresentacionesByProduct()
            this.$emit("successData");
          },
        });
      }
    },
    aplicarCompra() {
      let datos = { Id: this.Compra.Id };
      this.$alert.alertConfirm({
        action: "enviar a inventario",
        obj: "la compra",
        route: "AMC-Compras-applyCompra",
        data: datos,
        onSuccess: () => {
          //this.getPresentacionesByProduct()
          this.$emit("successData");
        },
      });
    },
    async getProveedores() {
      let proveedorArray = [];
      const database = await this.$store.getters.getFirebaseApp.database;
      const data = await database.queryBuilder("AMC/Provedores", []);
      if (data.exists()) {
        let arrayFactura = Object.entries(data.val());
        arrayFactura.forEach((element) => {
          proveedorArray.push({
            id: element[0],
            Nombre: element[1]["nom"],
          });
        });
        this.Proveedores = proveedorArray;
      }
    },
  },
  computed: {
    presentacionesMap() {
      return this.$pgsHelper.createIndex(this.presentaciones, "Id");
    },
    globalProdMap() {
      return this.$pgsHelper.createIndex(this.global_prod, "id");
    },

    proveedoresMap() {
      return this.$pgsHelper.createIndex(this.Proveedores, "id");
    },

    existenciasAlmacenes() {
      const resultado = { principal: null, secundarios: [] };

      if (!this.prodSelected) return resultado;

      const origenesProds = this.$store.getters.getOrigenes || [];
      const producto = this.globalProdMap.get(this.prodSelected);
      const UM = producto.Extra.AYB.UM;
      // Creamos un mapa local para búsqueda de origenes en O(1)
      const origenesMap = this.$pgsHelper.createIndex(this.origenes, "id");

      // Obtenemos el rendimiento de la presentación una sola vez fuera del bucle
      let rdm = 0;
      if (this.reqToAdd.prs && this.presentacionesMap) {
        const presentacion = this.presentacionesMap.get(this.reqToAdd.prs);
        if (presentacion && presentacion.rdm) {
          rdm = Number(presentacion.rdm) || 0;
        }
      }

      origenesProds.forEach((doc) => {
        const prodInfo = doc.Productos?.[this.prodSelected];

        // Si el producto no está en este origen, se omite la iteración
        if (!prodInfo) return;

        // Se busca el nombre real del almacén en el catálogo local en O(1)
        const origenInfo = origenesMap.get(doc.Origen);

        const almacenData = {
          id: doc.Origen,
          Stock: Number(prodInfo.Stock || 0),
          Nombre: origenInfo ? origenInfo.Nombre : "Sin Nombre",
          UM: UM,
        };

        if (rdm > 0) {
          almacenData.equivalente = almacenData.Stock / rdm;
          almacenData.prs = this.presentacionesMap.get(this.reqToAdd.prs).nom || "presentaciones";
          // console.log(almacenData.prs)
        }

        // Clasificación condicional directa
        if (this.Compra.amc == doc.Origen) {
          resultado.principal = almacenData;
        } else {
          resultado.secundarios.push(almacenData);
        }
      });

      return resultado;
    },

    agrupadosPorProveedor() {
      if (this.Compra.adq.length > 0) {
        // console.log(this.Compra.adq
        const grupos = this.Compra.adq.reduce((acc, item, index) => {
          // Usamos el nombre del proveedor directamente
          const proveedorNombre = item.proveedor;
          if (!acc[proveedorNombre]) {
            acc[proveedorNombre] = {
              proveedor: proveedorNombre, // Usamos el nombre como identificador.
              items: [],
            };
          }
          acc[proveedorNombre].items.push(item);
          return acc;
        }, {});

        return Object.values(grupos);
      } else {
        return [];
      }
    },

    modulos() {
      let dep = [
        /*{ value: "", text: "Seleccione un modulo" }*/
      ];
      let departamentos = this.$store.getters.getPDVDepartamentos;
      departamentos.forEach((element) => {
        dep.push({ value: element.id, text: element.Nombre });
      });
      return dep;
    },
    total() {
      let total = 0;
      if (this.Compra.adq) {
        this.Compra.adq.forEach((ins) => {
          total += Number(ins.pcu.C) * ins.cnt;
        });
      }

      return this.$pgsHelper.formatNumber(total);
    },
    presentacionesGlobal() {
      let presentaciones = [];
      const globalProdMap = this.globalProdMap;
      const proveedoresMap = this.proveedoresMap;

      this.presentaciones.forEach((pres) => {
        let proveedor = proveedoresMap.get(pres.pvd) || "";
        let producto = globalProdMap.get(pres.prd) || false;
        pres.title =
          producto.Nombre +
          " - " +
          pres.nom +
          " - " +
          pres.rdm +
          " " +
          producto.Extra?.AYB?.UM +
          "" +
          " - " +
          proveedor.Nombre;

        presentaciones.push(pres);
      });
      return presentaciones;
    },
    presentacionesPorProductoMap() {
      const map = new Map();
      this.presentacionesGlobal.forEach((pres) => {
        if (!map.has(pres.prd)) {
          map.set(pres.prd, []);
        }
        map.get(pres.prd).push(pres);
      });
      return map;
    },
    presentacionesBySelectedProd() {
      let presentaciones = [];
      const globalProdMap = this.globalProdMap;
      const proveedoresMap = this.proveedoresMap;

      this.presentaciones.forEach((pres) => {
        if (pres.prd == this.prodSelected) {
          let proveedor = proveedoresMap.get(pres.pvd) || "";
          let producto = globalProdMap.get(pres.prd) || false;
          pres.title =
            pres.nom +
            " - " +
            pres.rdm +
            " " +
            producto.Extra?.AYB?.UM +
            "" +
            " - " +
            proveedor.Nombre;
          presentaciones.push(pres);
        }
      });
      return presentaciones;
    },
    unidadMedida() {
      let prod = this.globalProdMap.get(this.reqToAdd.prd);

      if (prod) {
        return prod?.Extra?.AYB?.UM || "PZ";
      }
      return "";
    },
    global_prod() {
      let prod = this.$store.getters.getProductos;
      let productos = [];
      prod.forEach((element) => {
        if (
          (element.Tipo == "AYB-Insumo" || element.Tipo == "Producto") &&
          !element.Dlat
        ) {
          productos.push(element);
        }
      });

      let data = productos;
      let sortReservations = this.$_.orderBy(data, "Orden", "asc");
      return sortReservations;
    },
  },
  watch: {
    prodSelected() {
      this.reqToAdd.prs = "";
      this.reqToAdd.nom = "";
      this.reqToAdd.cnt = 1;
      this.reqToAdd.pcu = { C: 0, M: "MXN" };
    },
  },
  async beforeMount() {
    this.columnDefs = [
      {
        field: "nom",
        editable: true,
        cellEditor: "agSelectCellEditor",
        cellEditorParams: { values: this.presentaciones },
      },
      { field: "cnt", editable: true },
    ];
    this.getOrigenes();
    this.getOrdenesCompra();
    if (this.edit) {
      this.Compra = new Compra(this.dataEdit);
      this.notasProds = this.dataEdit.nts ? this.dataEdit.nts : "";

      if (this.Compra.ocm) {
        this.tipoOrden = "O";
      }
    } else {
      this.Compra = new Compra();
    }
    await this.getProveedores();
  },
};
</script>

<style scoped>
.noClick {
  pointer-events: none;
}
.centered-input >>> input {
  text-align: center;
}
/* Ocultar flechas del input number */
.centered-input >>> input[type="number"]::-webkit-inner-spin-button,
.centered-input >>> input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.centered-input >>> input[type="number"] {
  -moz-appearance: textfield;
}

/* Ocultar la barra en Firefox */
::v-deep .hide-scrollbar textarea {
  scrollbar-width: none;
}

/* Ocultar la barra en navegadores basados en WebKit (Chrome, Safari, Edge) */
::v-deep .hide-scrollbar textarea::-webkit-scrollbar {
  display: none;
}
</style>
